function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContactUs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 2825.559 2000",
    style: {
      enableBackground: "new 0 0 2825.559 2000"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#FAFAFA"
    },
    width: 2825.559,
    height: 2000
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 1561.3845,
    y1: 1443.0176,
    x2: 1520.1956,
    y2: 696.4568
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D1D7E0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EBEBFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.95,
      fill: "url(#SVGID_1_)"
    },
    d: "M1728.775,1023.929H1318.65c-32.402,0-58.67-26.267-58.67-58.669V555.134 c0-32.401,26.268-58.669,58.67-58.669h410.125c32.402,0,58.669,26.268,58.669,58.669V965.26 C1787.444,997.662,1761.178,1023.929,1728.775,1023.929z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1401.609,
    y: 903.842,
    style: {
      fill: "#96BFE6"
    },
    width: 244.206,
    height: 12.064
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1436.197,
    y: 941.856,
    style: {
      fill: "#96BFE6"
    },
    width: 175.029,
    height: 12.064
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000065064719661885474660000010955985167459499943_",
    gradientUnits: "userSpaceOnUse",
    x1: 2235.1641,
    y1: 1651.1495,
    x2: 2235.1641,
    y2: 882.5546
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D1D7E0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EBEBFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.95,
      fill: "url(#SVGID_00000065064719661885474660000010955985167459499943_)"
    },
    d: "M2526.996,1526.742h-583.664 c-38.171,0-69.115-30.943-69.115-69.115V748.518c0-38.172,30.944-69.115,69.115-69.115h583.664 c38.171,0,69.115,30.943,69.115,69.115v709.109C2596.111,1495.799,2565.167,1526.742,2526.996,1526.742z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2201.531,
    y: 1179.279,
    style: {
      fill: "#4598E6"
    },
    width: 57.256,
    height: 10.604
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1984.159,
    y: 1276.447,
    style: {
      fill: "#96BFE6"
    },
    width: 333.163,
    height: 20.529
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1984.159,
    y: 1375.014,
    style: {
      fill: "#96BFE6"
    },
    width: 269.413,
    height: 20.531
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1984.159,
    y: 1325.73,
    style: {
      fill: "#96BFE6"
    },
    width: 157.941,
    height: 20.53
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4598E6"
    },
    d: "M2404.482,763.902v10.369h61.053v57.298h10.368v-67.667H2404.482z M1989.895,831.569h10.369 v-57.298h61.052v-10.369h-71.421V831.569z M2465.535,1127.227v57.318h-61.053v10.369h71.421v-67.688H2465.535z M2000.264,1127.227 h-10.369v67.688h71.421v-10.369h-61.052V1127.227z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4598E6"
    },
    d: "M2443.58,1397.053c-33.666,0-61.057-27.391-61.057-61.057c0-33.667,27.391-61.057,61.057-61.057 s61.057,27.39,61.057,61.057C2504.637,1369.662,2477.246,1397.053,2443.58,1397.053z M2443.58,1286.756 c-27.15,0-49.239,22.089-49.239,49.24c0,27.15,22.089,49.238,49.239,49.238s49.239-22.088,49.239-49.238 C2492.819,1308.845,2470.73,1286.756,2443.58,1286.756z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#4598E6"
    },
    points: "2439.686,1360.027 2411.947,1332.287 2420.303,1323.932 2439.686,1343.314  2466.856,1316.143 2475.213,1324.498  "
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000158727572549405543520000014260612760467251127_",
    gradientUnits: "userSpaceOnUse",
    x1: 498.8389,
    y1: 1873.2251,
    x2: 2480.2969,
    y2: 1873.2251
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0052,
    style: {
      stopColor: "#1A2257"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5E60F2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000158727572549405543520000014260612760467251127_)"
    },
    d: "M2480.297,1873.225 c0,25.609-443.564,46.369-990.729,46.369c-547.165,0-990.729-20.76-990.729-46.369c0-25.608,443.564-46.368,990.729-46.368 C2036.732,1826.856,2480.297,1847.616,2480.297,1873.225z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000021823170620827541750000000944134844460051619_",
    gradientUnits: "userSpaceOnUse",
    x1: 1523.7124,
    y1: 1176.525,
    x2: 1523.7124,
    y2: 614.5236
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D1D7E0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EBEBFF"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 1345.948,
    y: 516.188,
    style: {
      opacity: 0.95,
      fill: "url(#SVGID_00000021823170620827541750000000944134844460051619_)"
    },
    width: 355.528,
    height: 305.041
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#385369"
    },
    d: "M1659.512,701.887c-11.709-30.975-39.838-45.196-53.118-49.629 c-4.729-1.57-13.175-4.327-22.074-7.207c-16.036-5.182-33.557-10.818-33.557-10.818h-55.335c0,0-19.16,6.422-39.524,13.559 c0,0.018-0.018,0.018-0.018,0.018c-18.759,6.578-38.513,13.751-45.179,17.102c-13.908,6.944-37.309,56.59-42.037,62.279 c-2.443,2.932-13.297,22.267-23.977,43.87h59.61c6.3-10.819,11.15-19.213,11.15-19.213s3.77,8.272,8.342,19.213h190.975 c3.02-12.704,4.904-28.706,4.904-28.706s10.226,13.908,21.394,28.706h55.038C1682.721,748.601,1666.108,719.371,1659.512,701.887z "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EEA886"
    },
    d: "M1529.688,482.178c0,0,43.267,6.816,36.679,74.51c-6.588,67.694-44.774,62.146-47.327,62.077 c-2.552-0.068-38.335,1.234-41.124-81.416C1477.916,537.349,1476.698,476.232,1529.688,482.178z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EEA886"
    },
    d: "M1567.036,537.566c0,0,4.737-5.06,6.476,0.063c1.738,5.123-6.463,27.973-6.757,29.041 c0,0-0.865,1.987-2.002,0.894C1563.615,566.47,1567.036,537.566,1567.036,537.566z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EEA886"
    },
    d: "M1479.082,536.71c0,0-4.64-5.151-6.477-0.063c-1.836,5.089,5.85,28.089,6.195,29.167 c0,0,0.826,2.003,1.984,0.932C1481.943,565.674,1479.082,536.71,1479.082,536.71z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434343"
    },
    d: "M1567.016,547.949l-6.194,8.281c0,0,0.175-18.155-0.818-21.002 c-0.994-2.846-2.515-11.543-3.346-13.594c-0.831-2.05-37.154-12.23-69.239,2.973c0,0,1.412,13.055-1.664,14.217 c-3.074,1.161-1.566,21.262-1.566,21.262l-5.094-5.747c0,0-7.795-52.081-5.87-57.509c1.925-5.429,8.06-38.065,73.884-18.691 c0,0,20.521-4.346,24.639,9.822C1575.865,502.128,1567.016,547.949,1567.016,547.949z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EEA886"
    },
    d: "M1556.129,633.01c-0.019-0.061-5.551-2.727-5.551-2.727c-2.695-6.027-0.693-31.457-0.693-31.457 s-55.105-14.025-53.532-3.301s-4.747,35.641-4.747,35.641l-28.27,14.037c0,0,30.12,80.875,64.737,70.441 c34.618-10.432,47.688-73.357,47.688-73.357L1556.129,633.01z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A77860"
    },
    d: "M1497.146,607.438c0,0,8.877,11.462,24.289,11.462c10.136,0,17.413-2.842,27.511-12.688 c0,0-4.378,18.699-27.444,20.439C1521.501,626.651,1504.775,628.777,1497.146,607.438z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0E2D3D"
    },
    d: "M1338.062,878.998c0,0,31.794,15.552,23.933,57.859c-7.86,42.309-11.34,48.01-2.546,64.541 c8.793,16.53,19.168,87.051,11.255,100.416c-7.914,13.365-97.955-58.737-110.441-119.234 c-12.486-60.496,7.914-87.402,15.124-97.427C1282.597,875.129,1309.993,864.754,1338.062,878.998z"
  })))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#163342"
    },
    d: "M1326.065,1860.865h7.205v-33.984c0,0,14.135,9.422,23.003,22.448 c8.868,13.025,21.062,11.917,39.63,11.085c18.567-0.831,17.737-8.313,16.074-18.845c-1.663-10.532-20.508-13.856-26.605-15.521 c-6.097-1.662-19.938-25.508-24.388-31.315c-6.07-7.92-9.284-15.519-9.284-15.519s-3.464-14.135-20.646,0 c-17.182,14.133-12.194,41.292-10.254,43.786S1326.065,1860.865,1326.065,1860.865z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EEA886"
    },
    d: "M1362.37,1826.049c6.374,4.158,23.002,0,23.002,0c-4.711-6.096-33.672-46.834-33.672-46.834 c-17.598-10.255-24.553,3.857-24.553,3.857C1334.327,1785.266,1355.996,1821.893,1362.37,1826.049z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EEA886"
    },
    d: "M1547.671,1199.13c0,0,11.536,2.212,15.478-3.211c3.352-4.61,11.014-8.148,13.37-9.242 c3.153-1.463,11.156-9.558,13.04-5.601s-12.552,13.979-15.158,16.686c-2.607,2.707,14.154,3.904,17.047,6.535 c2.892,2.631-0.665,30.282-12.074,28.129c-11.408-2.152-22.177-11.983-24.258-11.965c-2.082,0.02-8.363-1.238-8.363-1.238 L1547.671,1199.13z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EEA886"
    },
    d: "M1588.902,1203.166c0,0,34.49,8.91,36.292,11.428c1.802,2.519,1.208,4.358-2.052,3.66 c-3.26-0.699-33.573-7.646-33.573-7.646s39.05,17.406,40.977,19.146c1.128,1.02,0.19,4.65-1.589,4.438 c-1.779-0.212-41.47-15.251-41.47-15.251s36.431,16.317,37.608,18.254c1.031,1.694-0.665,4.812-3.45,3.786 c-2.784-1.023-37.454-14.258-37.454-14.258s25.77,13.544,25.801,15.769c0.019,1.361-0.646,4.537-7.186,0.835 c-6.541-3.703-22.887-10.818-22.887-10.818L1588.902,1203.166z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#163342"
    },
    d: "M1232.699,1863.186h4.434v-24.942c0,0,7.886,8.113,11.488,20.03 c3.604,11.916,16.502,15.45,36.179,14.896c19.676-0.555,19.954-8.322,18.291-19.961c-1.663-11.64-18.291-17.737-18.291-17.737 c-7.483-6.651-26.051-34.226-26.051-34.226s-11.917-3.188-21.269,4.363c-9.352,7.549-6.445,24.598-6.167,29.031 C1231.59,1839.075,1232.699,1863.186,1232.699,1863.186z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1D3B54"
    },
    d: "M1246.278,1269.01c0,0-23.447,30.484-29.806,66.65c-6.36,36.166,3.755,157.551,3.479,175.426 c-0.277,17.875-16.905,62.355-13.58,96.027s16.45,201.262,16.45,201.262l35.929-7.129c0,0-2.079-170.854,0-184.987 s6.25-65.653,7.082-71.474c0.832-5.819,52.779-158.639,52.779-184.713C1318.61,1333.997,1302.814,1226.469,1246.278,1269.01z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1D3B54"
    },
    d: "M1364.061,1280.926c0,0,38.521,147.02,43.095,167.39c4.572,20.369,11.196,37.169,11.196,45.817 c0,20.066-7.455,52.288-7.455,52.288l-48.916,233.953h-46.589c0,0,25.958-140.356,26.656-167.802 c0.7-27.506,21.874-66.566,17.717-78.207c-4.157-11.639-66.928-145.911-66.928-145.911S1245.309,1238.247,1364.061,1280.926z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EEA886"
    },
    d: "M1284.8,1835.472l-26.051-34.226l-21.269,4.363c0,0,5.723,15.319,16.062,26.844 C1265.787,1846.103,1284.8,1835.472,1284.8,1835.472z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#285173"
    },
    d: "M1348.151,1031.084c0,0,15.882,1.498,27.882,14.355s23.263,33.361,26.406,40.219 s47.201,70.408,49.487,71.837c2.285,1.429,24.432,8.828,39.105,13.767c22.645,7.621,68.036,24.117,68.036,24.117l-9.015,28.542 c0,0-85.354-27.929-106.73-33.195c-26.139-6.439-86.314-83.638-86.314-83.638S1312.149,1054.514,1348.151,1031.084z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFBF55"
    },
    d: "M1320.436,1019.941c0,0,20.572,9.715,27.715,11.143c7.143,1.429,34.859,37.431,39.716,50.574 c4.857,13.143,0,32.858-10.001,56.002c-10,23.145-0.571,30.859-5.143,54.002c-4.572,23.145-3.101,109.726-2.244,122.584 c0.857,12.857-133.739,32.347-160.311,8.918c0,0,17.989-78.031,39.287-100.303c4.606-4.815,4.119-36.913,0.977-44.914 c-3.144-8-38.573-67.717-38.573-67.717s-2.602-60.568,12.857-72.574c13.429-10.43,50.029-14.147,56.601-16.434 C1287.89,1018.938,1307.006,1017.941,1320.436,1019.941z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EEA886"
    },
    d: "M1330.258,996.201c0,0-0.614,5.664-1.324,13.319c-0.273,3.029-0.573,6.373-0.846,9.798 c-0.819,10.263-1.474,21.275-1.078,26.912c0,0-21.385,21.426-45.689-25.001c0,0,10.221-19.146,2.524-45.212 C1276.149,949.94,1330.258,996.201,1330.258,996.201z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#183C59"
    },
    d: "M1390.093,1146.195c0,0,5.146-34.227-0.326-55.041c0,0,0,17.899-9.813,43.314L1390.093,1146.195z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EEA886"
    },
    d: "M1264.894,1024.52c0,0,14.705,43.434,55.079,40.238c40.375-3.195,19.14-36.674,19.14-36.674 s-10.063-5.769-12.895-6.315c-2.832-0.545-44.638-1.074-44.638-1.074L1264.894,1024.52z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#285173"
    },
    d: "M1339.112,1028.084c0,0,21.146,58.494,21.146,118.111c0,59.616,1.703,156.73,9.086,187.398 s28.396,125.51,28.396,125.51l16.47-8.519c0,0-39.604-151.366-42.594-162.28c-2.99-10.915,2.271-126.223,5.111-135.877 c2.839-9.655,14.917-52.631,13.04-64.555c-2.367-15.03-16.432-37.271-39.148-56.394L1339.112,1028.084z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#285173"
    },
    d: "M1272.871,1022.691c0,0,13.145,42.084,19.804,95.983c6.66,53.898-20.445,304.082-38.618,360.874 l-70.422-11.358c0,0,15.159-176.841,35.737-209.024s27.126-60.656,4.912-127.826c-22.214-67.172,9.738-100.438,9.738-100.438 S1266.697,1023.389,1272.871,1022.691z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#616161"
    },
    points: "1348.847,1201.158 1263.46,1349.053 1168.537,1294.249 1250.215,1144.214  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E0CEC7"
    },
    points: "1338.554,1206.246 1262.719,1337.596 1178.415,1288.922 1250.956,1155.672  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#616161"
    },
    points: "1310.577,1194.446 1315.9,1185.227 1281.817,1165.549 1275.163,1174  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EEA886"
    },
    d: "M1306.509,1299.381c0,0-3.883,0.018-5.585-0.804c0,0-2.982-1.731-5.176-2.833 c-0.697-0.348-1.313-0.635-1.73-0.777c-1.741-0.604-5.743-1.404-9.52-4.027c-3.772-2.615-17.143-18.096-17.143-18.096 l6.315-9.603l4.63-9.833c0,0,28.073,1.813,31.872,3.846c0.371,0.201,0.729,0.412,1.049,0.637 c3.049,2.033,4.463,4.828,5.942,6.076c0.54,0.463,5.602,5.416,5.425,7.525c-0.241,2.928-1.597,4.859-3.363,5.824 c0,0-0.726,5.713-3.542,8.377c0,0-0.5,5.29-4.946,7.607C1310.738,1293.301,1309.629,1298.611,1306.509,1299.381z"
  }))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#285173"
    },
    d: "M1248.646,1031.084c0,0-25.93-7.429-40.788,21.145c-14.858,28.572-14.784,40.765-16.77,54.717 c-1.875,13.174-10.339,49.143-11.196,52.857c-0.857,3.714-20.027,48.008-11.237,63.488 c8.836,15.563,98.584,61.366,98.013,64.795s15.544-34.631,15.544-34.631s-36.315-20.241-42.263-26.473 c-9.661-10.124-30.042-21.031-25.854-33.59c4.918-14.752,19.693-64.522,23.122-71.809 C1240.646,1114.299,1270.505,1040.37,1248.646,1031.084z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EEA987"
    },
    d: "M1333.451,883.69c0,0,46.164,14.508,21.104,94.174c-25.061,79.665-88.106-9.232-81.512-57.771 C1279.638,871.555,1333.451,883.69,1333.451,883.69z"
  })))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0E2D3D"
    },
    d: "M1359.272,930.174c0,0-22.938,22.51-61.326,25.324c0,0-14.752,17.298-15.886,24.087 c0,0-34.25-58.38,7.852-93.376C1332.014,851.212,1374.748,915.754,1359.272,930.174z"
  })))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EEA987"
    },
    d: "M1298.408,957.083c-0.297-5.799-3.869-18.993-12.486-15.3s0.527,30.563,6.243,28.91 C1292.165,970.693,1299.111,970.801,1298.408,957.083z"
  })))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A77860"
    },
    d: "M1328.935,1009.521c-0.273,3.029-0.573,6.373-0.846,9.798c0,0-20.375-1.214-33.994-31.523 C1294.981,989.119,1309.911,1011.049,1328.935,1009.521z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000119106915527011158020000016253519048308779396_",
    gradientUnits: "userSpaceOnUse",
    x1: -3593.5527,
    y1: 1498.3564,
    x2: -3466.1646,
    y2: 1498.3564,
    gradientTransform: "matrix(-1 0 0 1 -2645.543 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#3076A1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#48C9B6"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000119106915527011158020000016253519048308779396_)"
    },
    d: "M823.438,1738.049 c29.6-20.815,64.243-165.885,66.309-252.291c1.059-44.262,14.142-62.701,25.685-78.97c11.034-15.552,20.564-28.982,15.013-59.82 c-10.608-58.934,17.282-84.374,17.566-84.623l-3.229-3.681c-1.241,1.087-30.287,27.325-19.155,89.172 c5.187,28.814-3.363,40.864-14.186,56.119c-11.358,16.008-25.492,35.93-26.587,81.686 c-2.218,92.73-37.635,229.701-64.231,248.404L823.438,1738.049z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000123426358949505138670000015825148214639897248_",
    gradientUnits: "userSpaceOnUse",
    x1: -3494.5764,
    y1: 1603.5096,
    x2: -3262.9885,
    y2: 1603.5096,
    gradientTransform: "matrix(-1 0 0 1 -2645.543 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#3076A1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#48C9B6"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000123426358949505138670000015825148214639897248_)"
    },
    d: "M761.394,1695.736 c-2.795-6.334-5.685-12.883-8.958-19.793c-16.91-35.694-31.888-41.572-56.705-51.311c-6.064-2.381-12.937-5.078-20.481-8.468 c-35.548-15.976-28.666-39.519-22.593-60.29c0.849-2.906,1.696-5.803,2.431-8.67c3.126-12.217-2.88-18.346-11.973-27.622 c-6.757-6.896-15.168-15.478-21.651-29.031c-7.095-14.833-3.479-22.786,0.805-26.846c9.018-8.548,29.812-6.973,49.445,3.745 c6.099,3.331,11.12,8.588,16.435,14.154c12.516,13.105,28.091,29.415,67.485,29.6c22.462,0.105,34.766,3.206,41.138,10.367 c7.231,8.125,5.869,20.291,3.981,37.128c-0.653,5.823-1.393,12.425-1.841,19.556c-2.68,42.547,22.437,73.241,22.685,73.54 c15.006,17.868,33.494,54.94,25.514,77.759c-3.344,9.565-10.824,15.585-22.232,17.892c-4.545,0.919-8.698,1.356-12.516,1.356 C784.808,1748.803,774.725,1725.952,761.394,1695.736z M669.366,1471.748c-17.532-9.57-36.332-11.502-43.731-4.488 c-5.623,5.328-2.972,14.459,0.244,21.179c6.132,12.821,13.889,20.735,20.732,27.718c9.514,9.707,17.028,17.375,13.218,32.263 c-0.748,2.92-1.609,5.87-2.475,8.829c-6.047,20.686-11.758,40.223,19.902,54.451c7.436,3.342,14.25,6.017,20.263,8.376 c25.051,9.831,41.601,16.325,59.341,53.772c3.301,6.969,6.204,13.549,9.012,19.912c15.313,34.707,24.556,55.657,58.035,48.888 c9.596-1.939,15.848-6.888,18.583-14.708c7.031-20.109-9.793-55.314-24.647-73.001c-1.088-1.304-26.624-32.435-23.817-76.99 c0.457-7.25,1.204-13.914,1.862-19.793c1.746-15.578,3.007-26.834-2.773-33.329c-5.285-5.938-16.852-8.629-37.505-8.726 c-41.475-0.194-57.847-17.339-71.003-31.114C679.344,1479.475,674.798,1474.714,669.366,1471.748L669.366,1471.748z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000160192477150816987010000009290867506543634314_",
    gradientUnits: "userSpaceOnUse",
    x1: -3474.7803,
    y1: 1637.1875,
    x2: -3300.958,
    y2: 1637.1875,
    gradientTransform: "matrix(-1 0 0 1 -2645.543 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#3076A1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#48C9B6"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000160192477150816987010000009290867506543634314_)"
    },
    d: "M824.349,1777.064l4.889-0.258 c-0.241-4.592-6.408-112.854-49.877-144.539c-47.689-34.762-62.725-72.117-69.885-97.193 c-8.438-29.546-51.385-37.442-53.21-37.764l-0.851,4.82c0.416,0.074,41.758,7.693,49.353,34.289 c7.36,25.77,22.8,64.152,71.709,99.803C818.082,1666.55,824.291,1775.963,824.349,1777.064z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000057853890801640882370000000174933308816909468_",
    gradientUnits: "userSpaceOnUse",
    x1: -3684.8945,
    y1: 1460.6116,
    x2: -3423.8701,
    y2: 1460.6116,
    gradientTransform: "matrix(-1 0 0 1 -2645.543 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#3076A1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#48C9B6"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000057853890801640882370000000174933308816909468_)"
    },
    d: "M816.074,1801.412 c-10.228-5.094-9.857-25.574-9.296-56.574c0.709-39.172,1.681-92.82-18.825-142.166c-21.784-52.419-2.356-67.74,16.433-82.557 c21.044-16.594,40.919-32.268,2.773-103.016c-17.52-32.492-23.083-54.471-17.505-69.166 c5.512-14.523,20.978-20.184,37.353-26.177c28.263-10.345,60.298-22.068,56.16-81.888c-1.268-18.338,0.887-29.615,6.785-35.49 c6.408-6.381,15.85-5.689,26.781-4.891c16.517,1.209,35.227,2.578,51.525-18.688c1.694-5.313,17.277-52.743,35.917-60.863 c3.914-1.705,7.75-1.684,11.403,0.063l0,0c12.868,6.154,20.335,13.454,22.829,22.316c4.339,15.413-6.952,32.798-20.025,52.928 c-20.544,31.634-43.831,67.488-19.679,110.155c31.932,56.415,15.066,76.158-8.277,103.483 c-13.373,15.654-28.531,33.397-38.665,62.338c-8.15,23.275,5.753,45.468,19.197,66.93c16.865,26.922,34.304,54.76-2.414,78.916 c-60.706,39.939-120.658,170.311-121.256,171.623l-0.248,0.542l-0.469,0.368c-11.184,8.766-19.326,12.949-25.457,12.949 C819.26,1802.549,817.59,1802.166,816.074,1801.412z M965.854,1612.977c32.718-21.524,17.999-45.021,0.956-72.227 c-13.405-21.398-28.598-45.65-19.669-71.147c10.437-29.805,25.91-47.919,39.563-63.899c22.872-26.773,37.982-44.461,7.738-97.892 c-25.614-45.253-0.414-84.056,19.835-115.234c12.425-19.132,23.156-35.655,19.419-48.935 c-2.091-7.426-8.707-13.715-20.229-19.226l0,0c-2.345-1.122-4.745-1.12-7.335,0.009c-17.295,7.532-33.174,57.743-33.333,58.25 l-0.127,0.406l-0.257,0.34c-17.963,23.737-39.074,22.193-56.04,20.949c-10.137-0.742-18.143-1.328-22.968,3.477 c-4.752,4.732-6.504,15.097-5.357,31.684c4.393,63.49-30.957,76.428-59.361,86.822c-15.958,5.841-29.74,10.885-34.458,23.316 c-5.035,13.27,0.442,33.958,17.237,65.107c40.099,74.366,17.655,92.066-4.05,109.182c-18.155,14.318-35.304,27.842-14.944,76.834 c20.899,50.291,19.918,104.529,19.2,144.133c-0.49,27.035-0.876,48.389,6.583,52.104c4.366,2.175,12.717-1.498,24.827-10.918 C847.938,1775.562,905.357,1652.777,965.854,1612.977z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000063626083542230970350000003080490327061029298_",
    gradientUnits: "userSpaceOnUse",
    x1: 883.935,
    y1: 1745.5405,
    x2: 731.9583,
    y2: 1289.6091
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#3076A1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#48C9B6"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000063626083542230970350000003080490327061029298_)"
    },
    d: "M720.254,1233.173 c30.896-10.593,24.477,48.955,37.532,93.015c13.055,44.06,145.233,19.221,89.751,129.55 c-55.482,110.329,70.169,36.897,32.637,133.175c-37.532,96.278-3.264,199.249-44.06,173.057 c-40.796-26.191-22.919-147.432-65.347-161.838c-42.428-14.406-49.351-31.209-7.344-70.372 c42.008-39.164-110.075-78.045-72.543-157.126C728.413,1293.551,684.559,1245.412,720.254,1233.173z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M821.894,1755.645c3.885-16.481,37.067-161.527,6.105-179.061 c-27.287-15.453-26.615-75.557-22.358-132.313c3.768-50.241-60.757-73.724-63.506-74.698l-1.637,4.613 c0.638,0.227,63.749,23.215,60.261,69.719c-4.371,58.287-4.84,120.139,24.828,136.939c23.508,13.312,1.864,129.883-8.459,173.677 L821.894,1755.645z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000000918340772263068960000014369774848528764580_",
    gradientUnits: "userSpaceOnUse",
    x1: 766.3508,
    y1: 2043.3005,
    x2: 842.3395,
    y2: 1715.728
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C9C4C1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFF6DE"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000000918340772263068960000014369774848528764580_)"
    },
    points: "938.462,1703.996  894.35,1871.35 795.771,1871.35 751.66,1703.996  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000148632961587485254180000014035679955652279938_",
    gradientUnits: "userSpaceOnUse",
    x1: 732.1264,
    y1: 1787.6729,
    x2: 918.9281,
    y2: 1787.6729,
    gradientTransform: "matrix(1 0 0 1 19.5338 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C9C4C1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFF6DE"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000148632961587485254180000014035679955652279938_)"
    },
    d: "M938.462,1703.996 c0,0-97.11,18.233-97.11,167.354h-45.58l-44.111-167.354H938.462z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000138568582554991506070000002384539523136802976_",
    gradientUnits: "userSpaceOnUse",
    x1: 2033.0205,
    y1: 701.3976,
    x2: 2033.0205,
    y2: 384.814
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D1D7E0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EBEBFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.95,
      fill: "url(#SVGID_00000138568582554991506070000002384539523136802976_)"
    },
    d: "M2178.551,650.154h-291.062 c-26.639,0-48.233-21.595-48.233-48.233V349.369c0-26.639,21.595-48.233,48.233-48.233h291.062 c26.639,0,48.234,21.595,48.234,48.233v252.552C2226.785,628.56,2205.189,650.154,2178.551,650.154z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2016.182,
    y: 584.144,
    style: {
      fill: "#4598E6"
    },
    width: 30.735,
    height: 5.692
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#344052"
    },
    d: "M2059.344,270.568c0,0,24.764,13.598,16.902,47.035c-7.862,33.437-10.852,37.852-4.463,51.363 c6.388,13.512,12.003,70.131,5.189,80.489c-6.813,10.358-75.889-50.524-83.564-99.23c-7.676-48.706,9.604-69.392,15.73-77.112 S2037.5,258.152,2059.344,270.568z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EEA886"
    },
    d: "M2105.841,546.927h-26.513c-1.282-13.078-2.467-22.181-2.224-23.528 c0.39-2.223-26.384-72.449-28.882-78.258c-2.516-5.793-12.332-21.369-13.614-36.038c-1.298-14.668,17.833-20.591,17.833-20.591 c25.815,4.625,34.561,40.338,34.561,40.338s10.84,72.417,16.324,92.797C2104.738,526.871,2105.5,536.104,2105.841,546.927z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EB4747"
    },
    d: "M2092.495,446.291l-39.481,16.646c0,0-36.291-90.056-5.873-80.001 C2077.469,392.96,2091.112,411.805,2092.495,446.291z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EB4747"
    },
    d: "M2083.709,488.691c-1.152,8.94-5.874,40.613-4.819,49.165c0.179,1.411,0.763,4.657,1.639,9.07 h-95.198c2.531-9.038,4.836-17.038,6.23-21.694c4.625-15.334,0.195-19.439-2.141-31.705c-0.909-4.803-4.105-13.923-7.595-24.227 c-1.168-3.44-2.368-7.025-3.521-10.627c-4.187-12.981-6.134-26.254-7.334-33.978c-5.744-36.622,22.424-40.144,22.424-40.144 c10.466-1.931,28.752-7.578,28.752-7.578l28.64,5.956c0,0,2.726,1.022,6.701,3.959c0,0,0.017,0,0.017,0.017 c1.914,1.411,4.121,3.261,6.441,5.646c3.131,3.213,9.362,12.412,15.577,22.521c1.898,3.1,3.813,6.279,5.614,9.411 c5.824,10.076,9.963,18.205,9.833,27.373C2094.855,460.881,2084.861,479.751,2083.709,488.691z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EEA886"
    },
    d: "M2050.787,382.94c0,0,17.942,30.665,11.27,32.955c-6.672,2.289-41.839-5.453-55.576-34.425 C2006.48,381.47,2029.564,370.978,2050.787,382.94z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EEA886"
    },
    d: "M2048.218,396.943c0,0-15.937,6.744-30.368-15.457c0,0,3.877-25.21-4.321-39.793 c-8.198-14.578,35.835,17.48,35.835,17.48s-0.713,3.006-1.451,7.444c-0.377,2.271-0.767,4.913-1.063,7.717 c-0.248,2.336-0.438,4.79-0.522,7.234C2046.144,387.239,2046.549,392.867,2048.218,396.943z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#393D63"
    },
    d: "M2008.644,431.289c-3.282,16.875-26.82,38.016-26.82,38.016c-1.164-3.449-2.364-7.027-3.517-10.624 C1994.547,448.318,2008.644,431.289,2008.644,431.289z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EEA886"
    },
    d: "M2002.74,444.719c-1.492,6.15-8.355,68.441-7.609,70.566c0.438,1.218,3.764,15.627,7.091,31.642 h-30.732c-3.147-10.319-5.014-18.888-4.56-23.739c1.963-21.012-5.16-87.993-5.16-87.993s-6.377-40.517,27.244-45.579 c0,0,19.861,2.613,21.062,17.281C2011.275,421.58,2004.233,438.586,2002.74,444.719z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EB4747"
    },
    d: "M1959.289,453.324l41.724,9.746c0,0,33.099-64.264,3.289-75.997 C1972.881,374.705,1951.756,418.269,1959.289,453.324z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EEA987"
    },
    d: "M2055.49,274.135c0,0,36.262,13.308,13.277,75.883c-22.983,62.575-69.902-10.682-62.814-49.135 C2013.041,262.432,2055.49,274.135,2055.49,274.135z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#344052"
    },
    d: "M2074.326,312.171c0,0-19.137,17.084-49.851,17.881c0,0-7.179,17.497-8.339,22.867 c0,0-30.344-52.1,4.543-78.417C2055.568,248.186,2087.209,301.256,2074.326,312.171z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EEA987"
    },
    d: "M2028.623,333.805c-0.019-4.634-2.369-15.289-9.379-12.669 c-7.01,2.62-0.731,24.389,3.888,23.286C2023.132,344.422,2028.667,344.77,2028.623,333.805z"
  })))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A77860"
    },
    d: "M2046.371,380.499c-17.04-4.713-23.63-20.955-23.832-21.498 c13.857,17.906,24.311,15.334,24.311,15.334C2046.602,376.671,2046.583,378.13,2046.371,380.499z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4598E6"
    },
    d: "M2125.131,364.297v5.566h32.773v30.759h5.566v-36.325H2125.131z M1902.57,400.622h5.566v-30.759 h32.773v-5.566h-38.34V400.622z M2157.904,559.338v30.77h-32.773v5.566h38.34v-36.336H2157.904z M1908.137,559.338h-5.566v36.336 h38.34v-5.566h-32.773V559.338z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1503.186,
    y: 844.906,
    style: {
      fill: "#4598E6"
    },
    width: 41.054,
    height: 7.603
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4598E6"
    },
    d: "M1646.744,551.257v7.435h43.775v41.085h7.435v-48.52H1646.744z M1349.47,599.776h7.435v-41.085 h43.776v-7.435h-51.211V599.776z M1690.52,811.771v41.101h-43.775v7.435h51.21v-48.535H1690.52z M1356.905,811.771h-7.435v48.535 h51.211v-7.435h-43.776V811.771z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DECBC4"
    },
    d: "M2440.762,1122.478h-34.725c-0.635-1.39-1.148-2.599-1.572-3.565 c-10.305-24.33-63.405-80.119-63.405-80.119s0,0.03,0,0.121c0,0-0.03,0.029-0.03,0.061c0,0,0,0.029,0,0.061 c-0.03,0.09-0.061,0.15-0.091,0.24c-0.03,0.121-0.061,0.273-0.121,0.455c-0.03,0.09-0.06,0.211-0.06,0.301 c-0.031,0.091-0.061,0.151-0.092,0.242c-2.176,8.13-12.874,48.628-18.223,82.204h-234.979c-0.543-3.112-1.178-6.075-1.903-8.824 c-2.146-8.342-3.597-16.593-4.534-24.299c-0.029-0.393-0.09-0.756-0.12-1.148c-0.182-1.421-0.333-2.841-0.454-4.231 c-2.024-21.095-0.514-37.264-0.393-38.896c-0.664,1.421-5.409,18.828-11.635,40.315c-3.416,11.787-7.284,24.813-11.122,37.083 h-55.488l69.632-200.887c1.541-1.209,19.614-9.942,32.791-16.229c13.449-6.407,29.679-15.808,44.336-23.846 c7.495-4.11,14.567-7.828,20.703-10.639l0.937-0.423v-0.029c10.124-4.625,16.864-7.678,16.864-7.678s0,0,0.029,0 c0.242-0.029,1.844-0.182,4.383-0.423c14.144-1.36,58.026-5.47,72.715-6.315c1.209-0.092,2.236-0.121,3.021-0.152 c0.665-0.029,1.179-0.029,1.48,0c1.844,0.121,10.91,3.265,22.788,7.798c0.453,0.151,0.907,0.332,1.359,0.514 c0.575,0.212,1.118,0.423,1.692,0.634c1.028,0.395,2.086,0.787,3.144,1.21c2.116,0.846,4.322,1.692,6.528,2.568 c0.756,0.303,1.541,0.604,2.327,0.907c23.784,9.43,51.045,21.125,57.513,25.779c4.291,3.053,17.619,28.168,33.063,59.235 C2413.744,1007.754,2434.083,1084.579,2440.762,1122.478z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EEA886"
    },
    d: "M2268.327,849.028c-0.626,31.587-61.783,48.866-61.783,48.866s-25.581-32.071-19.471-35.142 c2.399-1.207,3.374-5.994,3.673-11.361c0.277-5.109-0.049-10.746-0.348-14.326c-0.182-2.234-0.354-3.671-0.354-3.671 s8.737-9.22,19.854-20.203c19.426-19.208,46.131-43.813,46.173-34.024c0.002,0.518-0.069,1.138-0.226,1.855 C2251.152,803.05,2268.327,849.028,2268.327,849.028z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A77860"
    },
    d: "M2244.773,802.748c0,0,0,0-0.005,0.006c-0.12,0.184-2.714,4.065-7.142,9.634 c-9.388,11.81-27.037,31.21-46.881,39.003c0.277-5.109-0.049-10.746-0.348-14.326c-2.031-0.051-4.061-0.287-6.074-0.732 c5.441-9.504,13.297-19.47,13.297-19.47l12.277-3.673L2244.773,802.748z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EEA886"
    },
    d: "M2256.514,779.593c-5.291,11.509-10.314,19.851-11.74,23.155c0,0,0,0-0.005,0.006 c-0.927,2.152-3.452,5.661-7.142,9.634c-10.078,10.858-28.813,25.179-47.229,24.677c-2.031-0.051-4.061-0.287-6.074-0.732 c-7.436-1.625-16.217-5.08-21.049-14.54c-38.154-74.701-10.53-135.785-10.53-135.785s104.325-29.502,120.647,1.903 C2284.846,709.94,2268.943,752.551,2256.514,779.593z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E8734D"
    },
    d: "M2152.745,686.008c0,0-9.688-0.537-12.085-18.906c-2.367-18.148,2.42-23.178,2.42-23.178 s43.068-18.029,58.535-20.374c15.467-2.345,53.497-4.596,62.412,5.599c0,0,21.658-5.033,27.56,30.923 c9.361,57.042-31.899,112.431-31.899,112.431s0.352-37.266-7.866-42.203c-8.219-4.938-15.312,6.805-15.312,6.805l-16.812,3.011 c0,0,25.533-55.133-5.096-57.175C2183.975,680.898,2170.279,689.205,2152.745,686.008z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EEA886"
    },
    d: "M2236.972,722.248c1.599-16.418,31.288-22.685,29.3-5.479 c-1.988,17.209-16.609,33.741-23.363,33.159C2236.153,749.347,2235.752,734.762,2236.972,722.248z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3C4145"
    },
    d: "M2410.752,956.044c-9.672-30.977-18.043-55.487-21.76-58.147 c-6.498-4.654-57.997-18.828-82.446-28.408c-0.786-0.303-1.571-0.604-2.327-0.907c-2.206-0.876-4.412-1.723-6.528-2.568 c-1.058-0.423-2.115-0.815-3.144-1.21c-0.574-0.211-1.117-0.422-1.692-0.634c-0.452-0.182-0.906-0.362-1.359-0.514 c-0.03,0.03-0.061,0.091-0.121,0.12c-2.176,2.448-13.479,15.293-26.988,34.515c-25.266,35.903-58.178,94.081-53.13,147.786 c1.631,17.227,3.626,41.979,6.98,69.753c0.242,2.206,0.514,4.412,0.816,6.648h113.998c1.391-29.074,3.868-67.365,7.615-82.204 c0.031-0.091,0.061-0.151,0.092-0.242c0-0.09,0.029-0.211,0.06-0.301c0.03-0.152,0.091-0.303,0.121-0.455 c0.03-0.09,0.061-0.15,0.091-0.24c0-0.031,0-0.061,0-0.061c0-0.031,0.03-0.061,0.03-0.061s27.593,43.127,29.013,83.563h71.748 C2438.314,1084.912,2427.344,1009.205,2410.752,956.044z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3C4145"
    },
    d: "M2169.76,871.241c0,0-8.613,28.65-19.734,100.186c0,0,0,0,0,0.029 c-0.393,2.389-0.756,4.836-1.148,7.344c-0.03,0.273-0.091,0.574-0.121,0.877c-0.271,1.633-0.514,3.325-0.756,5.018 c-0.03,0.211-0.061,0.393-0.09,0.604c-0.182,1.118-0.363,2.267-0.515,3.444c-0.423,2.811-0.847,5.713-1.269,8.645 c-4.172,29.194-9.732,75.586-15.383,125.089h-45.063c-2.447-13.751-4.744-26.263-4.563-34.847 c-0.092,0.182-0.152,0.395-0.212,0.575c-3.597,9.973-7.556,20.823-11.575,31.37c-0.363,0.968-0.725,1.934-1.088,2.901h-77.671 l77.368-202.397c1.541-1.209,21.458-11.938,34.635-18.193c13.752-6.559,31.129-14.629,46.543-21.73 c7.373-3.415,14.295-6.588,20.158-9.278L2169.76,871.241z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#51565C"
    },
    d: "M2274.541,942.021l-29.77,16.804l12.724,12.966l-27.925,150.687h-10.518 c-3.869-30.464-6.075-57.814-7.797-76.401c-7.768-83.051,75.102-176.709,80.239-182.421c3.989,1.511,8.28,3.174,12.724,4.926 L2274.541,942.021z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#51565C"
    },
    d: "M2170.214,870.455c0,0-11.122,36.297-24.058,126.934c-4.17,29.164-9.762,75.586-15.412,125.089 h-4.383l-5.772-142.376l14.174-15.354l-12.603-15.745l26.959-68.847c7.373-3.415,14.295-6.588,20.158-9.278L2170.214,870.455z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5E2D9"
    },
    d: "M2292.996,864.011l-24.669-14.982c0,0-0.69,13.528-61.783,48.866l17.35,48.865L2292.996,864.011z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5E2D9"
    },
    d: "M2190.293,855.844c0,0,0.961,14.602,16.251,42.051l-33.86,44.141l-2.468-71.59L2190.293,855.844z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D44040"
    },
    d: "M2206.637,897.894c0,0,6.562,26.248,4.199,33.597c0,0-14.43,5.249-24.801-1.313 C2186.035,930.179,2193.381,911.805,2206.637,897.894z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D44040"
    },
    d: "M2198.683,987.143c-6.921,47.146-6.921,94.838-4.352,135.335h-28.923 c-0.393-5.712-0.756-11.665-1.118-17.892c-5.38-93.355,27.623-176.77,27.623-176.77l14.718-3.687 C2206.631,924.13,2201.887,965.383,2198.683,987.143z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2D3133"
    },
    d: "M2082.053,1045.317c-1.102,22.399-0.939,42.293-0.939,42.293s0,0.007,0,0.015 c-0.008,0.109-0.03,0.715-0.077,1.715c-0.046-0.38-0.093-0.752-0.14-1.125c-3.584,9.971-7.557,20.81-11.561,31.361 c-0.931-12.229-1.172-23.625-0.899-34.178c1.605-62.807,21.359-95.742,21.359-95.742 C2085.265,1000.604,2083.092,1024.09,2082.053,1045.317z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#292C47"
    },
    points: "1811.715,1122.746 1719.305,1173.543 1626.504,1027.505 1738.745,988.517  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "1805.855,1118.359 1719.436,1165.862 1632.65,1029.291 1737.615,992.83  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EEA886"
    },
    d: "M1837.504,1092.818c0,0-16.084-7.692-23.144-11.713c-7.06-4.021-25.222-9.541-26.688-10.852 c-1.467-1.311-53.835-4.541-57.011-7.281s-6.265,6.422,7.309,9.396c13.572,2.973,32.46,10.242,33.492,15.546 c1.033,5.305-13.94,6.562-15.457,10.932c-1.516,4.369,0.426,3.389,2.572,4.326c2.146,0.938,17.811-7.738,24.698-5.275 c6.888,2.461,17.417-0.947,22.697,0.859c5.279,1.808,30.95,10.445,30.95,10.445L1837.504,1092.818z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EEA886"
    },
    d: "M1714.801,1155.219c0,0-13.513-12.162-20.051-17.25c-6.537-5.086-18.811-20.052-20.617-20.924 c-1.807-0.871-25.242-48.963-29.062-50.889c-3.818-1.927,3.614-8.404,11.7,3.229s22.291,26.601,27.692,25.509 c5.401-1.093,0.755-15.692,4.281-18.823c3.527-3.13,3.36-0.918,5.079,0.739s-0.357,19.797,4.646,25.329 c5.003,5.533,5.89,16.783,9.648,21.055s21.895,25.099,21.895,25.099L1714.801,1155.219z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#424773"
    },
    d: "M2005.805,1805.243c0,0,2.923,20.288,3.288,23.335c0.365,3.049,32.516-1.795,32.516-1.795 l2.603-24.152C2044.211,1802.631,2009.823,1802.381,2005.805,1805.243z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#292C47"
    },
    d: "M2008.751,1825.999c0,0-10.187,12.226-20.038,17.554c-9.854,5.329-25.335,7.439-31.16,12.955 c-4.205,3.982-15.317,21.123,25.601,20.777c40.919-0.346,60.647,2.421,65.03-4.151c4.385-6.571-6.343-48.509-6.343-48.509 S2032.15,1828.112,2008.751,1825.999z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#424773"
    },
    d: "M1775.445,1805.243c0,0,2.923,20.288,3.288,23.335c0.365,3.049,32.516-1.795,32.516-1.795 l2.603-24.152C1813.852,1802.631,1779.465,1802.381,1775.445,1805.243z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#292C47"
    },
    d: "M1778.392,1825.999c0,0-10.187,12.226-20.039,17.554c-9.853,5.329-46.107,9.705-51.933,15.221 c-4.205,3.982-11.199,20.01,46.375,18.512c40.903-1.065,60.646,2.421,65.029-4.151c4.385-6.571-6.343-48.509-6.343-48.509 S1802.352,1828.35,1778.392,1825.999z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#292C47"
    },
    d: "M1979.182,1283.926c0,0,30.209,47.996,27.955,91.381c-2.254,43.386,10.953,90.752,15.492,136.074 c5.059,50.525,25.762,170.139,26.514,197.165c0.751,27.026-3.214,113.328-3.214,113.328l-41.444,0.948 c0,0-34.809-209.113-43.822-230.45c-9.015-21.337-53.721-173.452-55.223-190.521 C1903.937,1384.781,1979.182,1283.926,1979.182,1283.926z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#292C47"
    },
    d: "M1820.156,1290.429c0,0-22.766,118.911-25.771,145.465s-5.009,128.503-6.511,145.099 s-10.017,217.174-18.03,241.83h52.983c0,0,40.672-145.813,40.672-214.803c0-68.988,31.422-149.981,51.705-195.5 c20.283-45.52,66.711-46.596,79.18-131.05C1994.385,1281.47,1837.037,1263.644,1820.156,1290.429z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EEA886"
    },
    d: "M1928.771,880.405c0,0-40.547-15.145-59.243,15.72s-16.895,92.658,3.544,100.257 c20.439,7.599,51.141,3.625,61.604-15.688c10.464-19.313,19.911-47.234,19.457-65.895 C1953.68,896.14,1939.418,885.793,1928.771,880.405z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EEA886"
    },
    d: "M1877.474,997.795c0,0,1.688,10.947-1.102,16.341c-2.789,5.393,52.531,5.533,52.531,5.533 s4.491-29.333,13.005-54.117C1950.422,940.768,1877.474,997.795,1877.474,997.795z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3A3F47"
    },
    d: "M1941.908,965.552c0,0-3.816,6.299-19.402,3.854c-15.586-2.443-34.6-23.18-41.107-25.456 c-6.507-2.276-6.569-6.099-6.569-6.099l-4.073,5.951l-6.912,0.437c0,0,6.304-18.548-3.207-26.113 c-9.51-7.565,9.871-60.037,59.854-42.567c0,0,38.39,10.582,36.994,32.416C1956.09,929.808,1950.499,954.678,1941.908,965.552z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E2D2CA"
    },
    d: "M1873.088,1013.486c0,0,0.176-10.304,4.846-11.292c4.671-0.987,51.553-5.495,57.285-3.241v12.002 C1935.219,1010.955,1924.174,1017.754,1873.088,1013.486z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EEA886"
    },
    d: "M1875.861,929.91c0.875-3.662,10.188-14.127,13.753-2.922 c3.565,11.205-5.388,26.277-10.382,24.987C1874.238,950.685,1873.646,939.195,1875.861,929.91z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#323657"
    },
    d: "M1687.025,1135.229c0.021-0.009,0.046-0.012,0.076-0.006 C1686.781,1135.363,1686.734,1135.376,1687.025,1135.229z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFDF69"
    },
    d: "M2013.262,1398.266c0,0-24.866,7.321-67.271,11.995s-148.354-1.689-149.021-6.696 c-0.671-5.012,22.791-186.541,21.456-195.893c-1.334-9.348-2.051-42.658-2.051-42.658c-0.523,9.127-9.822,46.408-21.046,66.731 c-4.056,7.343-17.661,30.357-24.217,25.123c-31.741-25.343-80.892-120.841-84.007-121.646 c2.619-1.139,23.293-10.658,26.193-11.625c2.541-0.848,25.439,23.396,39.313,38.426c6.187,6.699,10.579,11.566,10.579,11.566 c4.006-9.014,18.6-65.801,23.133-85.455c10.229-44.323,8.656-46.166,8.656-46.166c31.021-9.384,78.108-28.483,78.108-28.483 l62.132-2.531c0,0,57.022,12.552,79.479,22.696c2.13,0.961,2.14,50.87,7.985,63.958l-18.619,39.279 c0,0-10.755,77.81-12.986,112.415C1990.055,1265.188,2013.262,1398.266,2013.262,1398.266z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFDF69"
    },
    d: "M2025.266,1162.404c-1.623,5.236-8.988,9.661-13.773,11.596c-3.063,1.24-6.494,1.641-9.947,1.001 l-2.434-0.45v-0.003l-42.578-7.896c0,0-9.317-107.294,58.167-133.001C2016.484,1034.234,2040.168,1114.364,2025.266,1162.404z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#AB9546"
    },
    d: "M2011.492,1173.997V1174c-3.063,1.24-6.494,1.641-9.947,1.001l-2.434-0.45v-0.003l4.199-54.828 L2011.492,1173.997z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#AB9546"
    },
    d: "M1763.191,1173.59l-5.204,22.038c0,0-5.647-22.114-5.375-33.604 C1758.799,1168.723,1763.191,1173.59,1763.191,1173.59z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3A3F47"
    },
    d: "M1940.32,884.047c0,0,53.14-6.655,0.902,82.108L1940.32,884.047z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#292C47"
    },
    points: "1669.225,1019.669 1663.822,1010.389 1706.369,995.709 1711.769,1004.94  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.95
    }
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000052096141537577537100000008455345422629509039_",
    gradientUnits: "userSpaceOnUse",
    x1: 2471.501,
    y1: 612.4077,
    x2: 2510.8691,
    y2: 612.4077
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D1D7E0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EBEBFF"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000052096141537577537100000008455345422629509039_)"
    },
    points: "2480.727,621.976  2510.869,621.976 2501.644,602.84 2471.501,602.84  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000149377781757782277070000007529766714454577084_",
    gradientUnits: "userSpaceOnUse",
    x1: 2457.3965,
    y1: 612.4077,
    x2: 2473.8047,
    y2: 612.4077
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D1D7E0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EBEBFF"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000149377781757782277070000007529766714454577084_)"
    },
    points: "2466.623,621.976  2473.805,621.976 2464.579,602.84 2457.396,602.84  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000013900760721848566260000012277685701430235022_",
    gradientUnits: "userSpaceOnUse",
    x1: 2358.4316,
    y1: 594.4019,
    x2: 2484.5352,
    y2: 594.4019
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D1D7E0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EBEBFF"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000013900760721848566260000012277685701430235022_)"
    },
    points: "2362.482,599.185  2484.535,599.185 2480.484,589.618 2358.432,589.618  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000178927506330190967690000003267823713819069629_",
    gradientUnits: "userSpaceOnUse",
    x1: 1658.1006,
    y1: 286.2993,
    x2: 1709.8213,
    y2: 286.2993
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D1D7E0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EBEBFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000178927506330190967690000003267823713819069629_)"
    },
    d: "M1707.004,294.093h-46.086 c-1.557,0-2.817-1.261-2.817-2.817v-9.953c0-1.556,1.261-2.816,2.817-2.816h46.086c1.557,0,2.817,1.261,2.817,2.816v9.953 C1709.821,292.832,1708.561,294.093,1707.004,294.093z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000047759597541722835390000000714634577821548167_",
    gradientUnits: "userSpaceOnUse",
    x1: 1658.1006,
    y1: 323.6753,
    x2: 1709.8213,
    y2: 323.6753
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D1D7E0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EBEBFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000047759597541722835390000000714634577821548167_)"
    },
    d: "M1707.004,331.469h-46.086 c-1.557,0-2.817-1.262-2.817-2.817v-9.952c0-1.557,1.261-2.817,2.817-2.817h46.086c1.557,0,2.817,1.261,2.817,2.817v9.952 C1709.821,330.207,1708.561,331.469,1707.004,331.469z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000138572552685454973350000008738617225774360219_",
    gradientUnits: "userSpaceOnUse",
    x1: 1658.1006,
    y1: 361.0518,
    x2: 1709.8213,
    y2: 361.0518
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D1D7E0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EBEBFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000138572552685454973350000008738617225774360219_)"
    },
    d: "M1707.004,368.846h-46.086 c-1.557,0-2.817-1.262-2.817-2.818v-9.952c0-1.556,1.261-2.817,2.817-2.817h46.086c1.557,0,2.817,1.262,2.817,2.817v9.952 C1709.821,367.584,1708.561,368.846,1707.004,368.846z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000051379230008312858290000013301214086180041896_",
    gradientUnits: "userSpaceOnUse",
    x1: 1731.1768,
    y1: 286.2993,
    x2: 1745.8926,
    y2: 286.2993
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D1D7E0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EBEBFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000051379230008312858290000013301214086180041896_)"
    },
    d: "M1743.076,294.093h-9.082 c-1.557,0-2.817-1.261-2.817-2.817v-9.953c0-1.556,1.261-2.816,2.817-2.816h9.082c1.556,0,2.816,1.261,2.816,2.816v9.953 C1745.893,292.832,1744.632,294.093,1743.076,294.093z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000163073173623011165860000008360826515870424195_",
    gradientUnits: "userSpaceOnUse",
    x1: 1731.1768,
    y1: 323.6753,
    x2: 1745.8926,
    y2: 323.6753
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D1D7E0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EBEBFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000163073173623011165860000008360826515870424195_)"
    },
    d: "M1743.076,331.469h-9.082 c-1.557,0-2.817-1.262-2.817-2.817v-9.952c0-1.557,1.261-2.817,2.817-2.817h9.082c1.556,0,2.816,1.261,2.816,2.817v9.952 C1745.893,330.207,1744.632,331.469,1743.076,331.469z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000121273596461522817010000007893166394544114100_",
    gradientUnits: "userSpaceOnUse",
    x1: 1731.1768,
    y1: 361.0518,
    x2: 1745.8926,
    y2: 361.0518
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D1D7E0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EBEBFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000121273596461522817010000007893166394544114100_)"
    },
    d: "M1743.076,368.846h-9.082 c-1.557,0-2.817-1.262-2.817-2.818v-9.952c0-1.556,1.261-2.817,2.817-2.817h9.082c1.556,0,2.816,1.262,2.816,2.817v9.952 C1745.893,367.584,1744.632,368.846,1743.076,368.846z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000049909180282749392490000015967114259690180250_",
    gradientUnits: "userSpaceOnUse",
    x1: 1526.2705,
    y1: 1118.6743,
    x2: 1596.9365,
    y2: 1118.6743
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D1D7E0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EBEBFF"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000049909180282749392490000015967114259690180250_)"
    },
    points: "1542.831,1135.849  1596.937,1135.849 1580.376,1101.5 1526.271,1101.5  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000050661113050189458800000005976831017833997475_",
    gradientUnits: "userSpaceOnUse",
    x1: 1500.9531,
    y1: 1118.6743,
    x2: 1530.4063,
    y2: 1118.6743
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D1D7E0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EBEBFF"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000050661113050189458800000005976831017833997475_)"
    },
    points: "1517.514,1135.849  1530.406,1135.849 1513.846,1101.5 1500.953,1101.5  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactUs);
export default __webpack_public_path__ + "static/media/contact_us.6db557170cf23b7b476c1c2fb27fc83c.svg";
export { ForwardRef as ReactComponent };